import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

@Component({
    selector: 'app-page-sign-in-1',
    templateUrl: './sign-in-1.component.html',
    styleUrls: ['./sign-in-1.component.scss'],
    standalone: false
})
export class PageSignIn1Component implements OnInit {
  constructor(private router: Router) {}

  ngOnInit() { }

  onSubmit() {
    this.router.navigate(['/default-layout/dashboard']);
  }
}
